import { string } from 'yup';

const obj = {
    field: [
      {
        title: "Topic or Keyword",
        attr: "language",
        value: "",
        placeholder: "Topic or Keyword",
        label: "Which language are you using, will enable markup highlights",
        type: "text",
        maxLength: 40,
        yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),

        id: "topic",
        // options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
        // max: 100,
        min: 3,
        required: true,
        error: "",
        example: `JavaScript`,
      },
     
    ],
    example: [
      {
        title: "Topic or Keyword",
        attr: "language",
        value: "Boxing",
        placeholder: "Topic or Keyword",
        label: "Which language are you using, will enable markup highlights",
        type: "text",
        maxLength: 40,
        yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),

        id: "topic",
        // options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
        // max: 100,
        min: 3,
        required: true,
        error: "",
        example: `JavaScript`,
      },
      
    ],
    editor: {
      output: `1. Boxing Equipment\n2. Boxing Gloves\n3. Boxing Classes\n4. Professional Boxing\n5. Amateur Boxing\n6. Women's Boxing\n7. Youth Boxing Programs\n8. Muay Thai Kickboxing\n9. MMA Fighting Techniques\n10. Speed Bag Training for Boxers\n11. Heavy Bag Workouts for Boxers\n12. Punching Combinations for Boxers\n13. Footwork Drills for Boxers`,  
      
      
      
       
       
       
       
        
        
        
        
      
      
       
       
      
    },
  };
  
  export default obj;
  